import { render, staticRenderFns } from "./BlockPopupDetails.vue?vue&type=template&id=65ac89d4&"
import script from "./BlockPopupDetails.vue?vue&type=script&lang=js&"
export * from "./BlockPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlockPopupDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports